import React, { useEffect } from 'react';
import { HotelBookingPolicies } from '@koob/booking';
import { useTranslation } from 'react-i18next';

const HotelBookingPoliciesWrapper = ({ rooms, setPolicies }) => {
  const { t } = useTranslation('booking');

  // Cancel/contracting conditions are returned inline on each selected bed
  // choice — no separate policies round-trip anymore.
  const policies = {
    cancelConditions: (rooms ?? []).flatMap(
      room => room?.bed?.cancelConditions ?? [],
    ),
    contractingConditions: (rooms ?? [])
      .map(room => room?.bed?.contractingConditions)
      .filter(Boolean)
      .join('<br><br>'),
  };

  useEffect(() => {
    setPolicies?.(policies);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(rooms)]);

  const policiesData = {
    displayName: t('contractingConditions'),
    from: t('room.from'),
    to: t('room.to'),
    cancellationFees: t('room.cancellationFees'),
  };

  return (
    <HotelBookingPolicies
      isLoading={false}
      translationData={policiesData}
      policies={policies}
    />
  );
};

export default HotelBookingPoliciesWrapper;
